module.exports = __webpack_public_path__ + "static/media/pages.63986911.svg";